module.exports = __webpack_public_path__ + "img/Placement.dc621fcb.jpg";